(ns ycweb.app.website.dlp.widgets.sectiontitle
  (:require
   [rum.core :as rum]
   [ycweb.components.headings :as headings]
   [util.transform :as trf]
   [ycweb.util.core :as u]))

(rum/defc section-title < rum/reactive [{:keys [isarticle]} {:keys [properties]}]
  (let [{:section-title/keys
         [title title-size show-content? title-flush?
          title-center? use-date-range? sub-title sub-title-placement
          spacer? on-page-link-id spacer-size]} properties

        below? (= sub-title-placement "below")]

    [:<>
     (when (and (u/presence title) show-content?)
       [:div.yc-section
        {:id (when (u/presence on-page-link-id) on-page-link-id)
         :class [(when (trf/toboolean isarticle) "yc-article")]}
        (headings/heading title
          {:type :h2
           :size title-size
           :flush (if below? true title-flush?)
           :center title-center?
           :pretext (when-not below? sub-title)
           :subtext (when below? sub-title)
           :dangerouslySetInnerHTML? true})
        (when (and spacer? use-date-range?)
          [:div
           {:class (u/bem :dlp-spacer [(if (= spacer-size "medium") :medium :standard)])}])])]))
